import { render, staticRenderFns } from "./AboutUsComponent.vue?vue&type=template&id=11f39154&scoped=true&"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js&"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f39154",
  null
  
)

export default component.exports